import React from 'react'

import { Grid } from '@material-ui/core';
import moment from 'moment'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { osName, osVersion } from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/esm/Skeleton';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const useStyles = makeStyles(theme => ({
    card : {
        width : '100%',
        maxWidth: '100%'
    },
    avatar: {
        backgroundColor: 'rgb(0, 160, 175)',
    },
    titleDark: {
    color: 'rgb(0, 0, 1)',
    fontWeight: 'bold',
    fontSize: '0.6rem'
    },
    titleLight: {
    color: 'rgb(0, 0, 1)',
    fontSize: '0.6rem'
    }
}));


const HomeInfoUserMobile = props => {
    
        const { customer, amount, accountType,authenticate, balances, skeleton, chart } = props
        const classes = useStyles();
        return (
            <div>
                <Grid container >
                    <Grid item xs={12} md={12} lg = {12} sm = {12}>   
                        { (skeleton) ?
                            <List>
                                <ListItem>
                                    <ListItemText
                                        primary={
                                            <Skeleton variant="text" /> 
                                        }
                                        secondary={
                                            
                                            <Skeleton variant="text" />
                                            
                                        } 
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar aria-label="recipe" >
                                            <Skeleton variant="circle" width={40} height={40} />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={
                                            <Skeleton variant="text" /> 
                                        }
                                        secondary={
                                            <React.Fragment>
                                                
                                                <Skeleton variant="text" />
                                                <br/>
                                                <Skeleton variant="text" />
                                                <br/>
                                                <Skeleton variant="text" />
                                                <br/>
                                                <Skeleton variant="text" />

                                            </React.Fragment>
                                            
                                        } 
                                    />
                                </ListItem>
                                {/* <ListItem>
                                    <ListItemText
                                        primary={
                                            <Skeleton variant="text" /> 
                                        }
                                        secondary={
                                            <div>
                                                <Skeleton variant="text" />
                                                <br/>
                                                <Skeleton variant="text" />
                                                <br/>
                                                <Skeleton variant="text" />
                                                <br/>
                                                <Skeleton variant="text" />
                                            </div>
                                        } 
                                    />
                                </ListItem> */}
                            </List>
                            :
                            <List>
                                <ListItem>
                                    <Card className = { classes.card }>
                                        <CardContent>

                                            <span className = { classes.titleLight }>
                                                <b>Último acceso: </b>{ moment(authenticate.updatedAt).format('DD/MM/YYYY, h:mm:ss') }
                                            </span> 
                                            <br/>
                                            <span className = { classes.titleLight }>
                                                { `${osName} ${osVersion} ` }
                                            </span>
                                        </CardContent>
                                    </Card>
                    
                                </ListItem>
                                <ListItem>
                                    <ListItemAvatar width={40} height={40}>
                                        <Avatar aria-label="recipe" className={classes.avatar}>
                                            { customer.Nombres.charAt(0) }
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={
                                            <React.Fragment>
                                                <Typography
                                                    component="span"
                                                    variant="body2"
                                                    color="textPrimary"
                                                    className={classes.titleDark}
                                                >
                                                    {`${ customer.Nombres } ${ customer.Apellidos }`}
                                                </Typography>
                                            </React.Fragment>
                                            
                                        }
                                        secondary={
                                            <React.Fragment>

                                                <Typography
                                                    component="span"
                                                    variant="body2"
                                                    color="textPrimary"
                                                    className={classes.titleLight}
                                                >
                                                    { (balances.Codigo !== undefined) ? `${balances.Codigo} ` : 0}
                                                </Typography>
                                                <br />
                                                <Typography
                                                    component="span"
                                                    variant="body2"
                                                    color="textPrimary"
                                                    className={classes.titleLight}
                                                >
                                                    { `${accountType} `}
                                                </Typography>
                                                <br />
                                                <Typography
                                                    component="span"
                                                    variant="body2"
                                                    color="textPrimary"
                                                    className={classes.titleLight}
                                                >
                                                    <b>{ `Cédula: `}</b>{ `${customer.Identificacion} `}
                                                </Typography>
                                                <br />
                                                <Typography
                                                    component="span"
                                                    variant="body2"
                                                    color="textPrimary"
                                                    className={classes.titleDark}
                                                >
                                                    { `Saldo: $${amount}`}
                                                </Typography>

                                            </React.Fragment>
                                            
                                        } 
                                    />
                                </ListItem>
                                {/* <ListItem>
                                    <ListItemText
                                        primary={
                                            <b>{ `Consulta de Creditos` } </b> 
                                        }
                                        secondary={
                                            <div>
                                                <b>{ `Operación: `}</b>{ `${credits.NumeroCredito} `}
                                                <br/>
                                                <b>{ `Vencido: `}</b>{ `$ 0.00 `}
                                                <br/>
                                                <b>{ `Tipo Operación: `}</b>{ `ORIGINAL `}
                                                <br/>
                                                <b>{ `Por Vencer: `}</b>{ `$51,188.35 `}
                                                
                                            </div>
                                        } 
                                    />
                                </ListItem> */}
                            </List>   
                        }
                        { chart }
                    </Grid>
                    
                </Grid>
            </div>
        )
    }

export default HomeInfoUserMobile;
